import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  ROUTE_ALLOWED_FUNCTIONS = environment.api_location + "/allowed-functions";
  //Amv04
  ROUTE_MENU_CONTROL = environment.api_location + "/allowed-menu";
  menuControl;
  //Amv04 end

  sidebarItems = [
    {
      name: "New Booking",
      icon: "fa-plus",
      link: "/new-booking",
      // allowed: true
      allowed: false
    },
    //Amv01
    {
      name: "EDI Booking",
      icon: "fa-envelope",
      link: "/edi-booking",
      // allowed: true
      allowed: false
    },
    //Amv01 end
    {
      name: "Bookings",
      icon: "fa-book",
      link: "/bookings",
      allowed: false
    },
    {
      name: "Products",
      icon: "fa-boxes",
      link: "/products",
      allowed: false
    },
    {
      name: "Warehouse",
      icon: "fa-warehouse",
      //Amv04
      link: "",
      isGroup: true,
      children: [
        {
          name: "Stock Transfer",
          icon: "fa-arrow-right-arrow-left",
          link: "/stock-transfer",
          allowed: false
        },
        {
          name: "Stock Taking",
          icon: "fa-clipboard-check",
          link: "/products",
          allowed: false
        },
        {
          name: "Bin Overview",
          icon: "fa-th",
          link: "/products",
          allowed: false
        }
      ],
      //Amv04 end
      allowed: false
    },
    {
      name: "Dashboard",
      icon: "fa-chart-bar",
      link: "/dashboard",
      // allowed: true
      allowed: false
    },
    {
      name: "Data",
      icon: "fa-database",
      link: "/database",
      // allowed: true
      allowed: false
    }
  ];

  constructor (private http: HttpClient) { }

  // For now just check warehouse allowed or not. Future can add more restraints here.
  checkAllowedFunctions() {

    //Amv04
    // this.http.get(this.ROUTE_ALLOWED_FUNCTIONS).subscribe(response => {
    //   let allowedFunctions = response as any;
    //   this.sidebarItems.find(sidebarItem => sidebarItem.name == 'Bookings').allowed = allowedFunctions.Bookings;
    //   this.sidebarItems.find(sidebarItem => sidebarItem.name == 'Products').allowed = allowedFunctions.Products;
    // });

    this.http.get(this.ROUTE_MENU_CONTROL).subscribe(response => {
      this.menuControl = response;
      console.log(this.menuControl);

      if(this.menuControl){
        for(let menuData of this.menuControl){
          console.log(menuData['menu_name']);

          switch(menuData['menu_name']){

            case "Dashboard":
              this.sidebarItems.find(sidebarItem => sidebarItem.name == "Dashboard").allowed = true;
              break;
            case "Bin Overview":
              const warehouse1 = this.sidebarItems.find(sidebarItem => sidebarItem.name == "Warehouse");

              if(warehouse1){
                warehouse1.allowed = true;
                const submenu = warehouse1.children?.find(submenu => submenu.name == "Bin Overview");

                if(submenu){
                  submenu.allowed = true;
                }
              }

              break;
            case "Products":
              this.sidebarItems.find(sidebarItem => sidebarItem.name == "Products").allowed = true;
              break;
            case "New Booking":
              this.sidebarItems.find(sidebarItem => sidebarItem.name == "New Booking").allowed = true;
              break;
            case "Stock Taking":
              const warehouse = this.sidebarItems.find(sidebarItem => sidebarItem.name == "Warehouse");

              if(warehouse){
                warehouse.allowed = true;
                const submenu = warehouse.children?.find(submenu => submenu.name == "Stock Taking");

                if(submenu){
                  submenu.allowed = true;
                }
              }

              break;
            case "Bookings":
              this.sidebarItems.find(sidebarItem => sidebarItem.name == "Bookings").allowed = true;
              break;
            case "Stock Transfer":
              const warehouse2 = this.sidebarItems.find(sidebarItem => sidebarItem.name == "Warehouse");

              if(warehouse2){
                warehouse2.allowed = true;
                const submenu = warehouse2.children?.find(submenu => submenu.name == "Stock Transfer");

                if(submenu){
                  submenu.allowed = true;
                }
              }

              break;
            case "Data":
              this.sidebarItems.find(sidebarItem => sidebarItem.name == "Data").allowed = true;
              break; 
            case "EDI Booking":
              this.sidebarItems.find(sidebarItem => sidebarItem.name == "EDI Booking").allowed = true;
              break; 
          }

        }
      }

    });
    //Amv04 end
  
  }
}